export const CRYPTO_MARKET_DATA_SOURCE = Object.freeze({
  SELF_BUILT: 1,
  POLYMARKET: 2,
});

/** 与侧栏 CRYPTO_PRICE_SLUG_MAP / Go cryptoSidebarPeriodTags 对齐（小写）。 */
export const CRYPTO_SIDEBAR_PERIOD_TAG_SLUGS = Object.freeze(
  new Set(['5m', '15m', '1h', '4h', 'daily', 'weekly', 'monthly', 'yearly', 'pre-market', 'etf'])
);

/**
 * 与 Go dual_liquidity.short_cycle_venue 对齐。
 * 空 = 信任后端 cryptoPage* 过滤（推荐）；SELF/PM = 前端再滤一层。
 */
export function resolveCryptoShortCycleVenue(raw = process.env.VUE_APP_SHORT_CYCLE_VENUE) {
  const v = String(raw ?? '')
    .trim()
    .toUpperCase();
  if (v === 'PM' || v === 'SELF') return v;
  return '';
}

/**
 * 分钟盘现货是否跟 Polymarket（目标价 / Chainlink RTDS）。
 * 行上 liquiditySource / dataSource 优先；缺省时跟 short_cycle_venue。
 */
export function isPmVenueUpdownRow(collection, market = null) {
  const row = collection && typeof collection === 'object' ? collection : null;
  const m = market || (Array.isArray(row?.markets) ? row.markets[0] : null);
  const liq = String(m?.liquiditySource ?? row?.liquiditySource ?? '')
    .trim()
    .toUpperCase();
  if (liq === 'PM') return true;
  if (liq === 'SELF') return false;
  const dataSource = resolveCryptoFeedDataSource(row);
  if (dataSource === CRYPTO_MARKET_DATA_SOURCE.POLYMARKET) return true;
  if (dataSource === CRYPTO_MARKET_DATA_SOURCE.SELF_BUILT) return false;
  return resolveCryptoShortCycleVenue() === 'PM';
}

/**
 * 分钟盘现货数据源。PM 必须走 polymarket（Chainlink / crypto-price），禁止回落 binance。
 * @returns {'polymarket'|'binance'}
 */
export function resolveUpdownSpotFeedKind(collection, market = null) {
  return isPmVenueUpdownRow(collection, market) ? 'polymarket' : 'binance';
}

/** CollectionVo 的来源以首个 market 为准；旧响应缺 market 时兼容 collection.dataSource。 */
export function resolveCryptoFeedDataSource(row) {
  const markets = Array.isArray(row?.markets) ? row.markets : [];
  const raw = markets[0]?.dataSource ?? row?.dataSource;
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
}

export function cryptoFeedRowHasSidebarPeriodTag(row) {
  const tags = Array.isArray(row?.tags) ? row.tags : [];
  return tags.some((tag) =>
    CRYPTO_SIDEBAR_PERIOD_TAG_SLUGS.has(
      String(tag?.slug || '')
        .trim()
        .toLowerCase()
    )
  );
}

function isShortCyclePeriodRow(row, isUpdown) {
  return Boolean(isUpdown) || cryptoFeedRowHasSidebarPeriodTag(row);
}

/**
 * 加密短周期展示策略（与 Go cryptoSidebar 同旋钮）：
 * - 空 venue：信任后端（cryptoPage 已按 short_cycle_venue 过滤）→ 全部保留
 * - SELF：丢弃 PM 的 updown / 侧栏周期 tag 行；普通非周期 PM 保留
 * - PM：丢弃自建 updown / 侧栏周期 tag 行；禁止与残留币安窗口混切
 * 来源缺失时保守保留。
 */
export function shouldKeepCryptoFeedRowBySource(row, isUpdown, venue = resolveCryptoShortCycleVenue()) {
  const mode = String(venue ?? '')
    .trim()
    .toUpperCase();
  if (!mode) return true;

  const dataSource = resolveCryptoFeedDataSource(row);
  if (dataSource == null) return true;

  const period = isShortCyclePeriodRow(row, isUpdown);
  if (mode === 'PM') {
    if (dataSource === CRYPTO_MARKET_DATA_SOURCE.SELF_BUILT && period) return false;
    return true;
  }
  // SELF
  if (dataSource === CRYPTO_MARKET_DATA_SOURCE.POLYMARKET && period) return false;
  return true;
}
